<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      ref="grid"
    ></dx-grid>
    <!-- Import dialog -->
    <v-dialog v-model="importDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Import Persons</v-card-title>
        <v-card-text class="pt-0">
          <input
            type="file"
            ref="importFileInput"
            @change="onFileChange"
            accept=".xls,.xlsx"
            style="display: none"
          />
          <v-btn
            :disabeld="importProcessing"
            small
            outline
            color="success"
            class="mt-0"
            :loading="uploading"
            @click="pickFile()"
            ><v-icon dark left>mdi-cloud-upload</v-icon>Upload</v-btn
          >
          <div v-if="importFile" class="">
            {{ importFile.name }}
          </div>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="importDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="importProcessing"
            color="success"
            @click="submitImport"
            :disabled="!importFile"
          >
            Import
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Search Account dialog -->
    <v-dialog persistent v-model="searchDialog" max-width="1400">
      <v-card class="pt-2">
        <!-- Auto Match trigger button -->
        <v-layout class="px-4 pb-0" justify-space-between v-if="selectedRow">
          <v-btn
            class="mb-1"
            small
            color="success"
            @click="openCreateNewAccountDialog"
          >
            <v-icon left>mdi-account-plus</v-icon>Create New account
          </v-btn>
          <!-- <v-btn
            class="mb-1"
            small
            color="success"
            @click="openAutoMatchDialog"
          >
            <v-icon left>mdi-magnify</v-icon>Auto Match
          </v-btn> -->
          <v-btn
            flat
            color="success"
            class="my-0"
            icon
            @click="closeSearchDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>
        <div
          class="my-2 mx-4"
          v-if="selectedRow"
          style="border:2px solid #4caf50;"
        >
          <div
            class="title mb-0 px-3 py-1"
            style="background: #4caf50;color:white;"
          >
            Selected Person
          </div>
          <div class="px-4 py-2">
            <v-layout row wrap>
              <v-flex xs6 class="pr-2">
                <v-layout row class="mb-1">
                  <div class="font-weight-medium mr-2">Master Contact ID:</div>
                  {{ selectedRow.masterContactID }}
                </v-layout>
                <v-layout row class="mb-1">
                  <div class="font-weight-medium mr-2">Name:</div>
                  {{ selectedRow.firstName }}
                  {{ selectedRow.lastName }}
                </v-layout>
                <v-layout row v-if="selectedRow.hebrewFirstName" class="mb-1">
                  <div class="font-weight-medium mr-2">Hebrew Name:</div>
                  {{ selectedRow.hebrewFirstName }}
                  {{ selectedRow.hebrewLastName }}
                </v-layout>
                <v-layout row v-if="selectedRow.addressLine1" class="mb-1">
                  <div class="font-weight-medium mr-2">Address:</div>
                  {{ selectedRow.addressLine1 }}
                </v-layout>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-layout row v-if="selectedRow.fatherName" class="mb-1">
                  <div class="font-weight-medium mr-2">Father:</div>
                  {{ selectedRow.fatherName }}
                </v-layout>
                <v-layout row v-if="selectedRow.fatherInLawName" class="mb-1">
                  <div class="font-weight-medium mr-2">Father In Law:</div>
                  {{ selectedRow.fatherInLawName }}
                </v-layout>
                <v-layout row v-if="selectedRow.conflictTypes" class="mb-1">
                  <div class="font-weight-medium mr-2">Conflict Types:</div>
                  {{ selectedRow.conflictTypes }}
                </v-layout>
                <v-layout row v-if="selectedRow.conflictActions" class="mb-1">
                  <div class="font-weight-medium mr-2">Conflict Actions:</div>
                  {{ formatConflictActions(selectedRow.conflictActions) }}
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <data-grid
          v-if="showDonorsGrid"
          class="accounts-search"
          url="donors"
          :perPage="6"
          :dontSaveFilters="true"
          :columns="donorsColumns"
          :title="searchDialogTitle"
          navigationPath="Account View"
          navigationField="accountID"
          v-bind:hideActions="true"
          :onRowClicked="onSearchAccountsRowClicked"
          :sortOptions="{
            enabled: true,
            field: 'lastHebrew',
            type: 'asc',
          }"
        ></data-grid>
      </v-card>
    </v-dialog>

    <!-- Confirmation dialog -->
    <v-dialog v-model="confirmDialog" max-width="600">
      <v-card>
        <v-card-title class="headline pb-0">Confirm Link Account</v-card-title>
        <v-card-text class="pt-3">
          <div class="mb-3">
            <div class="font-weight-medium">Genvite Person:</div>
            <div v-if="selectedRow" class="ml-3">
              <div>Master Contact ID: {{ selectedRow.masterContactID }}</div>
              <div>
                Name: {{ selectedRow.firstName }} {{ selectedRow.lastName }}
              </div>
              <div v-if="selectedRow.hebrewFirstName">
                Hebrew Name: {{ selectedRow.hebrewFirstName }}
                {{ selectedRow.hebrewLastName }}
              </div>
              <div v-if="selectedRow.addressLine1">
                Address: {{ selectedRow.addressLine1 }}
              </div>
              <div v-if="selectedRow.fatherName">
                Father: {{ selectedRow.fatherName }}
              </div>
              <div v-if="selectedRow.fatherInLawName">
                Father In Law: {{ selectedRow.fatherInLawName }}
              </div>
            </div>
          </div>
          <div class="mb-2">
            <div class="font-weight-medium">UTA Account:</div>
            <div v-if="selectedAccount" class="ml-3">
              <div>UTA ID: {{ selectedAccount.personID }}</div>
              <div>Name: {{ selectedAccount.name }}</div>
              <div v-if="selectedAccount.nameH">
                Hebrew Name: {{ selectedAccount.nameH }}
              </div>
              <div v-if="selectedAccount.address1">
                Address: {{ selectedAccount.address1 }}
              </div>
              <div v-if="selectedAccount.father">
                Father: {{ selectedAccount.father }}
              </div>
              <div v-if="selectedAccount.fatherInLaw">
                Father In Law: {{ selectedAccount.fatherInLaw }}
              </div>
            </div>
          </div>
          <div class="mt-3 font-weight-medium">
            Are you sure you want to link these accounts?
          </div>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="confirmDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="submitLinkAccount"
          >
            Confirm & Link
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Genvite Portal dialog -->
    <v-dialog v-model="genvitePortalDialog" max-width="1200">
      <v-card>
        <v-card-title class="headline py-2">
          Genvite Portal - Contact ID: {{ genviteMasterContactID }}
          <v-spacer></v-spacer>
          <v-btn
            small
            color="success"
            class="mr-2"
            @click="openGenviteExternal"
          >
            <v-icon left>mdi-open-in-new</v-icon>Open in new tab
          </v-btn>
          <v-btn class="my-0" icon @click="closeGenvitePortal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <div class="px-3 pt-2 pb-2" style="background: #f5f5f5;">
            <v-layout row wrap align-center class="mb-1">
              <div class="font-weight-medium">Connection log</div>
              <v-spacer></v-spacer>
              <v-btn
                small
                outline
                color="success"
                class="my-0"
                @click="copyGenviteLog"
              >
                <v-icon left>mdi-clipboard-text</v-icon>Copy log
              </v-btn>
            </v-layout>
            <textarea
              readonly
              :value="genviteDebugLog"
              class="genvite-debug-log"
            ></textarea>
          </div>
          <iframe
            v-if="genvitePortalUrl"
            ref="genviteIframe"
            :src="genvitePortalUrl"
            style="width: 100%; height: 520px; border: none;"
            @load="onGenviteIframeLoad"
            @error="onGenviteIframeError"
          ></iframe>
          <div
            class="px-4 pb-3 pt-2 caption grey--text"
            v-if="genvitePortalUrl"
          >
            If you see a login loop, this site may block authentication inside
            an embedded window. Use "Open in new tab" above.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Auto Match dialog -->
    <v-dialog v-model="autoMatchDialog" max-width="1200">
      <v-card>
        <v-card-title class="headline py-2">
          Auto Match - Master Contact ID:
          {{ selectedRow && selectedRow.masterContactID }}
          <v-spacer></v-spacer>
          <v-btn class="my-0" icon @click="autoMatchDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <div v-if="autoMatchLoading" class="pa-4">Loading matches...</div>
          <div v-else>
            <div
              v-if="!autoMatchResults || autoMatchResults.length === 0"
              class="pa-4"
            >
              No matches found.
            </div>
            <v-data-table
              v-else
              :headers="autoMatchHeaders"
              :items="autoMatchResults"
              item-key="personID"
              dense
              class="elevation-0"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.personID"
                    @click="onAutoMatchRowClicked(item)"
                    :class="{
                      'selected-row':
                        autoMatchSelected &&
                        autoMatchSelected.personID === item.personID,
                    }"
                    style="cursor: pointer;"
                  >
                    <td>
                      <v-icon
                        :color="item.genviteAnslIDs ? 'success' : '#f35123'"
                      >
                        {{
                          item.genviteAnslIDs ? "mdi-check-circle" : "mdi-alert"
                        }}
                      </v-icon>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.nameH }}</td>
                    <td>
                      <span
                        :class="{
                          'font-weight-medium':
                            autoMatchSelected &&
                            autoMatchSelected.personID === item.personID,
                        }"
                      >
                        {{ item.personID }}
                      </span>
                    </td>
                    <td>{{ item.address1 }}</td>
                    <td>{{ item.emailAddress }}</td>
                    <td>{{ item.father }}</td>
                    <td>{{ item.fatherInLaw }}</td>
                    <td>{{ item.genviteAnslIDs }}</td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="autoMatchDialog = false"
            >Close</v-btn
          >
          <v-btn
            color="success"
            :disabled="!autoMatchSelected"
            @click="saveAutoMatch"
          >
            Save Match
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Conflicts dialog -->
    <v-dialog v-model="conflictsDialog" max-width="900">
      <v-card>
        <v-card-title class="headline pt-2 pb-0">
          Conflicts Detected
          <v-spacer></v-spacer>
          <v-btn class="my-0" icon @click="conflictsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <div class="mb-3">
            <v-alert type="success" class="mb-3 pa-2" value="true" outline>
              The accounts were successfully linked!
            </v-alert>
            <!-- Linked data summary -->
            <div
              v-if="selectedRow && selectedAccount"
              class="mb-3"
              style="border: 1px solid #4caf50; border-radius: 4px;"
            >
              <div class="px-3 py-1" style="background: #4caf50; color: white;">
                Linked Data
              </div>
              <div class="pa-3">
                <v-layout row>
                  <v-flex xs6 class="pr-3">
                    <div
                      class="text-success subtitle-1 font-weight-medium mb-2"
                    >
                      Genvite Person
                    </div>
                    <div class="mb-1">
                      <span class="font-weight-medium mr-2"
                        >Master Contact ID:</span
                      >
                      {{ selectedRow.masterContactID }}
                    </div>
                    <div class="mb-1">
                      <span class="font-weight-medium mr-2">Name:</span>
                      {{ selectedRow.firstName }} {{ selectedRow.lastName }}
                    </div>
                    <div class="mb-1" v-if="selectedRow.hebrewFirstName">
                      <span class="font-weight-medium mr-2">Hebrew Name:</span>
                      {{ selectedRow.hebrewFirstName }}
                      {{ selectedRow.hebrewLastName }}
                    </div>
                    <div class="mb-1" v-if="selectedRow.addressLine1">
                      <span class="font-weight-medium mr-2">Address:</span>
                      {{ selectedRow.addressLine1 }}
                    </div>
                    <div class="mb-1" v-if="selectedRow.fatherName">
                      <span class="font-weight-medium mr-2">Father:</span>
                      {{ selectedRow.fatherName }}
                    </div>
                    <div class="mb-1" v-if="selectedRow.fatherInLawName">
                      <span class="font-weight-medium mr-2"
                        >Father In Law:</span
                      >
                      {{ selectedRow.fatherInLawName }}
                    </div>
                  </v-flex>
                  <v-flex xs6 class="pl-3">
                    <div
                      class="text-success subtitle-1 font-weight-medium mb-2"
                    >
                      UTA Account
                    </div>
                    <div class="mb-1">
                      <span class="font-weight-medium mr-2">UTA ID:</span>
                      {{ selectedAccount.personID }}
                    </div>
                    <div class="mb-1">
                      <span class="font-weight-medium mr-2">Name:</span>
                      {{ selectedAccount.name }}
                    </div>
                    <div class="mb-1" v-if="selectedAccount.nameH">
                      <span class="font-weight-medium mr-2">Hebrew Name:</span>
                      {{ selectedAccount.nameH }}
                    </div>
                    <div class="mb-1" v-if="selectedAccount.address1">
                      <span class="font-weight-medium mr-2">Address:</span>
                      {{ selectedAccount.address1 }}
                    </div>
                    <div class="mb-1" v-if="selectedAccount.father">
                      <span class="font-weight-medium mr-2">Father:</span>
                      {{ selectedAccount.father }}
                    </div>
                    <div class="mb-1" v-if="selectedAccount.fatherInLaw">
                      <span class="font-weight-medium mr-2"
                        >Father In Law:</span
                      >
                      {{ selectedAccount.fatherInLaw }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </div>
            <div class="font-weight-medium text-danger">
              However, the following conflicts were detected that need to be
              taken care of:
            </div>
          </div>

          <div style="max-height: 300px; overflow-y: auto;">
            <v-data-table
              :headers="[
                { text: 'Conflict Type', value: 'conflictType' },
                { text: 'Field', value: 'field' },
                { text: 'Genvite', value: 'genvite' },
                { text: 'UTA', value: 'uta' },
                { text: 'Action', value: 'action' },
              ]"
              :items="conflicts"
              item-key="id"
              dense
              class="elevation-1"
              hide-default-footer
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.conflictType }}</td>
                  <td>{{ props.item.field }}</td>
                  <td>{{ props.item.genvite }}</td>
                  <td>{{ props.item.uta }}</td>
                  <td style="max-width: 275px;">
                    <v-select
                      v-model="props.item.action"
                      :items="actionOptions"
                      item-text="label"
                      item-value="value"
                      dense
                      hide-details
                      class="pt-0"
                    ></v-select>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="conflictsDialog = false"
            >Close</v-btn
          >
          <v-btn color="success" @click="saveConflicts">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Create New Account Confirmation dialog -->
    <v-dialog v-model="createNewAccountDialog" max-width="600">
      <v-card>
        <v-card-title class="headline pb-0">
          <span>Create New Account in UTA</span>
        </v-card-title>
        <v-card-text class="pt-2">
          <template v-if="hasExistingAdditionConflict()">
            <div class="mb-3">
              <v-alert type="info" value="true" outlined>
                <div class="font-weight-medium">
                  A new UTA account will be created for this Genvite person.
                </div>
              </v-alert>
            </div>
          </template>
          <template v-else>
            <div class="mb-3">
              <div class="font-weight-medium">Genvite Person:</div>
              <div v-if="selectedRow" class="ml-3">
                <div>Master Contact ID: {{ selectedRow.masterContactID }}</div>
                <div>
                  Name: {{ selectedRow.firstName }} {{ selectedRow.lastName }}
                </div>
                <div v-if="selectedRow.hebrewFirstName">
                  Hebrew Name: {{ selectedRow.hebrewFirstName }}
                  {{ selectedRow.hebrewLastName }}
                </div>
                <div v-if="selectedRow.addressLine1">
                  Address: {{ selectedRow.addressLine1 }}
                </div>
                <div v-if="selectedRow.fatherName">
                  Father: {{ selectedRow.fatherName }}
                </div>
                <div v-if="selectedRow.fatherInLawName">
                  Father In Law: {{ selectedRow.fatherInLawName }}
                </div>
              </div>
            </div>
            <div class="mt-3 font-weight-medium">
              This will create a new account in UTA for this Genvite person. The
              account will be created based on the Genvite person's information
              and will be linked to the Genvite Master Contact ID. Are you sure
              you want to proceed?
            </div>
          </template>
        </v-card-text>
        <v-card-actions class="pb-3 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="createNewAccountDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            v-if="!hasExistingAdditionConflict()"
            :loading="creatingAccount"
            color="success"
            @click="submitCreateNewAccount"
          >
            Confirm & Create
          </v-btn>
          <v-btn
            v-if="hasExistingAdditionConflict()"
            :loading="creatingAccount"
            color="success"
            @click="submitUpdateConflictAction"
          >
            Submit Action
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "Genvite Persons",

    processing: false,
    uploading: false,
    importDialog: false,
    importFile: null,
    importProcessing: false,
    url: "genviteData?onlyNotLinked=",
    actions: [],
    searchDialog: false,
    searchDialogTitle: "Search Account",
    selectedRow: null,
    confirmDialog: false,
    selectedAccount: null,
    showDonorsGrid: false,
    genvitePortalDialog: false,
    genvitePortalUrl: null,
    genviteMasterContactID: null,
    genviteDebugLog: "",
    genviteWindowErrorHandler: null,
    genviteRejectionHandler: null,
    autoMatchDialog: false,
    autoMatchLoading: false,
    autoMatchResults: [],
    autoMatchSelected: null,
    autoMatchHeaders: [],
    conflictsDialog: false,
    conflicts: [],
    actionOptions: [
      { value: "conflict-update", label: "Conflict: Update From Genvite" },
      { value: "conflict-ignore", label: "Conflict: Ignore" },
    ],
    createNewAccountDialog: false,
    creatingAccount: false,

    donorsColumns: [
      {
        field: "genviteAnslIDs",
        isIcon: true,
        icon: (value) => {
          return value ? "mdi-check-circle" : "mdi-alert";
        },
        iconColor: (value) => {
          return value ? "success" : "#f35123";
        },
      },
      {
        sortable: true,
        label: "Last Name",
        field: "lastEnglish",
        hidden: false,
        width: "200px",
        filterOptions: {
          enabled: true,
          placeholder: "Search Last Name..",
        },
      },
      {
        sortable: true,
        label: "First Name",
        field: "firstEnglish",
        hidden: false,
        width: "200px",
        filterOptions: {
          enabled: true,
          placeholder: "Search First Name..",
        },
      },
      {
        sortable: true,
        label: "Last Hebrew",
        field: "lastHebrew",
        hidden: false,
        width: "200px",
        filterOptions: {
          enabled: true,
          placeholder: "Search Last Hebrew..",
        },
      },
      {
        sortable: true,
        label: "First Hebrew",
        field: "firstHebrew",
        hidden: false,
        width: "200px",
        filterOptions: {
          enabled: true,
          placeholder: "Search First Hebrew..",
        },
      },
      {
        sortable: false,
        label: "Donor ID",
        field: "personID",
        width: "115px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Donor ID..",
        },
      },
      {
        sortable: false,
        label: "Address",
        field: "address1",
        width: "200px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Address..",
        },
      },
      {
        sortable: false,
        label: "Email",
        field: "emailAddress",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Email..",
        },
      },
      {
        sortable: false,
        label: "Father",
        field: "father",
        width: "250px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Father..",
        },
      },
      {
        sortable: false,
        label: "Shver",
        field: "fatherInLaw",
        width: "250px",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Shver..",
        },
      },
      {
        sortable: true,
        label: "Genvite",
        field: "genviteAnslIDs",
        hidden: false,
        filterOptions: {
          enabled: true,
          placeholder: "Search Shver..",
        },
      },
    ],

    columns: [
      {
        label: "Uta ID",
        field: "utaID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
      },
      {
        label: "Master Contact ID",
        field: "masterContactID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
      },
      {
        label: "Title",
        field: "title",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Name",
        field: "firstName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name",
        field: "lastName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Title",
        field: "hebrewTitle",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew First Name",
        field: "hebrewFirstName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        sortOrder: "asc",
        sortIndex: 1,
      },
      {
        label: "Hebrew First Name Additions",
        field: "hebrewFirstNameAddditions",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Last Name",
        field: "hebrewLastName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        sortOrder: "asc",
        sortIndex: 0,
      },
      {
        label: "Hebrew Suffix",
        field: "hebrewSuffix",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address Line 1",
        field: "addressLine1",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Apt",
        field: "apt",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        type: "number",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Conflict Types",
        field: "conflictTypes",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Conflict Actions",
        field: "conflictActions",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father-in-law Name",
        field: "fatherInLawName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father Name",
        field: "fatherName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father Master Contact ID",
        field: "fatherMasterContactID",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father-in-law Master Contact ID",
        field: "fatherInLawMasterContactID",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address Line 2",
        field: "addressLine2",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "City",
        field: "city",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "State",
        field: "state",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Zip",
        field: "zip",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Country",
        field: "country",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Phone Number",
        field: "phoneNumber",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.actions.push({
      text: "Import",
      action: this.openImportDialog,
    });

    // Add toggle switch to show only not linked persons (utaID == "NOT LINKED")
    this.actions.push({
      text: "UTA ID Not Linked",
      type: "switch",
      align: "left",
      action: this.onShowNotLinkedChanged,
    });

    this.columns.find((c) => c.field == "utaID").linkAction = (row) => {
      if (row.utaID == "NOT LINKED") {
        this.openSearchDialog(row);
      } else {
        this.$router.push({
          name: "DinnerAccountView",
          params: {
            id: row.utaID,
          },
        });
      }
    };

    this.columns.find((c) => c.field == "masterContactID").linkAction = (
      row
    ) => {
      this.openGenvitePortal(row.masterContactID);
    };

    // Build headers for auto match table based on donorsColumns
    this.autoMatchHeaders = this.donorsColumns.map((c) => ({
      text: c.label,
      value: c.field,
      sortable: false,
    }));
  },
  watch: {
    genvitePortalDialog(value) {
      if (!value) {
        this.unbindGenviteWindowErrors();
      }
    },
  },
  beforeDestroy() {
    this.unbindGenviteWindowErrors();
  },
  methods: {
    hasExistingAdditionConflict() {
      if (
        !this.selectedRow ||
        !this.selectedRow.conflicts ||
        !Array.isArray(this.selectedRow.conflicts)
      ) {
        return false;
      }

      return this.selectedRow.conflicts.some(
        (conflict) =>
          conflict.conflictType && conflict.conflictType.trim() === "ADDITION"
      );
    },
    getExistingAdditionConflict() {
      if (
        !this.selectedRow ||
        !this.selectedRow.conflicts ||
        !Array.isArray(this.selectedRow.conflicts)
      ) {
        return null;
      }

      return (
        this.selectedRow.conflicts.find(
          (conflict) =>
            conflict.conflictType && conflict.conflictType.trim() === "ADDITION"
        ) || null
      );
    },
    getActionLabel(actionValue) {
      if (!actionValue) return "";

      const actions = [
        { value: "conflict-update", label: "Conflict: Update From Genvite" },
        { value: "conflict-ignore", label: "Conflict: Ignore" },
        {
          value: "new-account-create",
          label: "New Account: Create New account",
        },
        {
          value: "new-account-link",
          label: "New Account: Link with existing account",
        },
      ];

      const option = actions.find((opt) => opt.value === actionValue);
      return option ? option.label : actionValue;
    },
    formatConflictActions(actions) {
      if (!actions) return "";
      let values = [];
      if (Array.isArray(actions)) {
        values = actions;
      } else if (typeof actions === "string") {
        values = actions
          .split(",")
          .map((val) => val.trim())
          .filter(Boolean);
      } else {
        values = [actions];
      }

      if (!values.length) return "";

      return values.map((val) => this.getActionLabel(val)).join(", ");
    },
    getGenviteAppUser() {
      return this.$store &&
        this.$store.state &&
        this.$store.state.authentication
        ? this.$store.state.authentication.user || ""
        : "";
    },
    formatGenviteLogTime() {
      const now = new Date();
      const pad = function(n) {
        return n < 10 ? "0" + n : String(n);
      };
      return (
        pad(now.getHours()) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds())
      );
    },
    addGenviteLog(message) {
      const line = "[" + this.formatGenviteLogTime() + "] " + message;
      this.genviteDebugLog = this.genviteDebugLog
        ? this.genviteDebugLog + "\n" + line
        : line;
      console.log("[Genvite Portal] " + message);
    },
    bindGenviteWindowErrors() {
      this.unbindGenviteWindowErrors();
      this.genviteWindowErrorHandler = (event) => {
        const msg =
          (event && event.message) ||
          (event && event.error && event.error.message) ||
          "Unknown window error";
        const source = event && event.filename ? " source=" + event.filename : "";
        this.addGenviteLog("window error: " + msg + source);
      };
      this.genviteRejectionHandler = (event) => {
        const reason =
          event && event.reason
            ? event.reason.message || String(event.reason)
            : "Unknown unhandled rejection";
        this.addGenviteLog("unhandled rejection: " + reason);
      };
      window.addEventListener("error", this.genviteWindowErrorHandler);
      window.addEventListener("unhandledrejection", this.genviteRejectionHandler);
    },
    unbindGenviteWindowErrors() {
      if (this.genviteWindowErrorHandler) {
        window.removeEventListener("error", this.genviteWindowErrorHandler);
        this.genviteWindowErrorHandler = null;
      }
      if (this.genviteRejectionHandler) {
        window.removeEventListener(
          "unhandledrejection",
          this.genviteRejectionHandler
        );
        this.genviteRejectionHandler = null;
      }
    },
    buildGenvitePortalUrl(masterContactID) {
      const masterId = masterContactID != null ? String(masterContactID) : "";
      const apiKey =
        "ee81f16620d0455d89aabdd9c12bd214c10b3c5619b8412786cba4163a3ebbdd";
      const localUser = this.getGenviteAppUser();
      return (
        "https://portal.genvite.com/app/premium?id=" +
        encodeURIComponent(masterId) +
        "&apikey=" +
        encodeURIComponent(apiKey) +
        "&localuser=" +
        encodeURIComponent(localUser)
      );
    },
    openGenvitePortal(masterContactID) {
      const masterId = masterContactID != null ? String(masterContactID) : "";
      const localUser = this.getGenviteAppUser();
      this.genviteMasterContactID = masterContactID;
      this.genvitePortalUrl = this.buildGenvitePortalUrl(masterContactID);
      this.genviteDebugLog = "";
      this.bindGenviteWindowErrors();
      this.addGenviteLog("Opening Genvite portal");
      this.addGenviteLog("Master Contact ID: " + masterId);
      this.addGenviteLog("localuser: " + (localUser || "(empty)"));
      this.addGenviteLog("page URL: " + window.location.href);
      this.addGenviteLog(
        "document.referrer: " + (document.referrer || "(empty)")
      );
      this.addGenviteLog("iframe URL: " + this.genvitePortalUrl);
      this.genvitePortalDialog = true;
    },
    closeGenvitePortal() {
      this.unbindGenviteWindowErrors();
      this.genvitePortalDialog = false;
    },
    onGenviteIframeLoad() {
      this.addGenviteLog("iframe load event fired");
      const iframe = this.$refs.genviteIframe;
      if (!iframe) {
        this.addGenviteLog("error: iframe ref missing after load");
        return;
      }
      try {
        const win = iframe.contentWindow;
        const loc = win && win.location ? win.location.href : "(no location)";
        const doc = iframe.contentDocument;
        const title = doc && doc.title ? doc.title : "(no title)";
        const bodyText =
          doc && doc.body && doc.body.innerText
            ? doc.body.innerText.replace(/\s+/g, " ").slice(0, 300)
            : "(no body text)";
        this.addGenviteLog("iframe location: " + loc);
        this.addGenviteLog("iframe title: " + title);
        this.addGenviteLog("iframe body: " + bodyText);
      } catch (e) {
        const message = e && e.message ? e.message : String(e);
        this.addGenviteLog(
          "iframe is cross-origin after load (Genvite page reached the iframe). " +
            message
        );
      }
    },
    onGenviteIframeError(event) {
      const message =
        event && event.message
          ? event.message
          : "iframe error event fired (no extra detail from browser)";
      this.addGenviteLog("iframe error: " + message);
    },
    async copyGenviteLog() {
      const text = this.genviteDebugLog || "";
      if (!text) {
        this.$notify({
          type: "error",
          group: "notification",
          text: "No Genvite log to copy",
        });
        return;
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const input = document.createElement("textarea");
          input.value = text;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.$notify({
          type: "success",
          group: "notification",
          text: "Genvite connection log copied",
        });
      } catch (e) {
        this.$notify({
          type: "error",
          group: "notification",
          text: "Failed to copy Genvite log",
        });
      }
    },
    openGenviteExternal() {
      if (this.genvitePortalUrl) {
        this.addGenviteLog("Opening URL in new tab: " + this.genvitePortalUrl);
        window.open(this.genvitePortalUrl, "_blank");
      }
    },
    async openCreateNewAccountDialog() {
      if (!this.selectedRow) return;

      try {
        const response = await this.$http.get(
          "api/genviteConflicts/getConflictsForGenvitePerson?masterContactID=" +
            this.selectedRow.masterContactID
        );

        // Handle response format (could be response.data or just response)
        const conflicts = response;
        this.selectedRow.conflicts = Array.isArray(conflicts) ? conflicts : [];
      } catch (e) {
        // If API call fails, set conflicts to empty array
        this.selectedRow.conflicts = [];
      }

      this.createNewAccountDialog = true;
    },
    async submitCreateNewAccount() {
      if (!this.selectedRow) return;

      try {
        this.creatingAccount = true;

        const payload = {
          masterContactID: this.selectedRow.masterContactID,
          conflictType: "ADDITION",
        };

        const response = await this.$http.post(
          "api/genviteConflicts/saveNewConflict",
          payload
        );

        this.$notify({
          type: "success",
          group: "notification",
          text: "New account conflict created successfully",
        });

        this.createNewAccountDialog = false;
        this.searchDialog = false;
        this.selectedRow = null;

        // Refresh the grid
        if (this.$refs.grid && this.$refs.grid.reloadGrid) {
          this.$refs.grid.reloadGrid();
        }
      } catch (e) {
        // Attempt to surface structured error from server if present
        const errData =
          e && e.response && e.response.data ? e.response.data : null;
        if (errData && errData.error) {
          const details = Array.isArray(errData.details)
            ? errData.details.join("\n")
            : null;
          this.$notify({
            type: "error",
            group: "notification",
            text: details ? `${errData.error}\n${details}` : errData.error,
          });
        } else {
          this.$notify({
            type: "error",
            group: "notification",
            text: "Failed to create new account conflict",
          });
        }
      } finally {
        this.creatingAccount = false;
      }
    },
    async submitUpdateConflictAction() {
      if (!this.selectedRow) return;

      const existingConflict = this.getExistingAdditionConflict();
      if (!existingConflict) {
        this.$notify({
          type: "error",
          group: "notification",
          text: "Existing conflict not found",
        });
        return;
      }

      try {
        this.creatingAccount = true;

        const payload = [
          {
            id: existingConflict.id,
            masterContactID: existingConflict.masterContactID,
            conflictType: existingConflict.conflictType,
            personID: existingConflict.personID,
            field: existingConflict.field,
            genvite: existingConflict.genvite,
            uta: existingConflict.uta,
            importID: existingConflict.importID,
            action: "new-account-create",
            byUser: this.$store.state.authentication.user || "",
          },
        ];

        const response = await this.$http.post(
          "api/genviteConflicts/updateConflicts",
          payload
        );

        this.$notify({
          type: "success",
          group: "notification",
          text: "Conflict action updated successfully",
        });

        this.createNewAccountDialog = false;
        this.searchDialog = false;
        this.selectedRow = null;

        // Refresh the grid
        if (this.$refs.grid && this.$refs.grid.reloadGrid) {
          this.$refs.grid.reloadGrid();
        }
      } catch (e) {
        this.$notify({
          type: "error",
          group: "notification",
          text: "Failed to update conflict action",
        });
      } finally {
        this.creatingAccount = false;
      }
    },
    openAutoMatchDialog() {
      if (!this.selectedRow) return;
      this.autoMatchDialog = true;
      this.autoMatchSelected = null;
      this.autoMatchResults = [];
      this.autoMatchLoading = true;
      this.fetchAutoMatches();
    },
    async fetchAutoMatches() {
      if (!this.selectedRow) return;
      try {
        const resp = await this.$http.post("api/genvite/autoMatch", {
          masterContactID: this.selectedRow.masterContactID,
        });
        const data = resp && resp.data ? resp.data : resp;
        this.autoMatchResults = Array.isArray(data) ? data : [];
      } catch (e) {
        this.$notify({
          type: "error",
          group: "notification",
          text: "Failed to load auto matches",
        });
      } finally {
        this.autoMatchLoading = false;
      }
    },
    onAutoMatchRowClicked(item) {
      this.autoMatchSelected = item;
    },
    saveAutoMatch() {
      // Placeholder - to be implemented later
      if (!this.autoMatchSelected) return;
      this.$notify({
        type: "info",
        group: "notification",
        text: "Save Match functionality will be implemented.",
      });
    },
    async saveConflicts() {
      try {
        this.processing = true;

        // Build payload with only conflicts that have a selected action
        const items = (this.conflicts || []).filter((c) => c && c.action);
        if (!items.length) {
          this.$notify({
            type: "error",
            group: "notification",
            text: "Please select an action for at least one conflict",
          });
          this.processing = false;
          return;
        }

        const payload = items.map((c) => ({
          id: c.id,
          masterContactID:
            (this.selectedRow && this.selectedRow.masterContactID) ||
            c.masterContactID,
          conflictType: c.conflictType,
          personID:
            (this.selectedAccount && this.selectedAccount.personID) ||
            c.personID,
          field: c.field,
          genvite: c.genvite,
          uta: c.uta,
          importID: c.importID,
          action: c.action,
          byUser:
            (this.$store &&
            this.$store.state &&
            this.$store.state.authentication
              ? this.$store.state.authentication.user
              : "") || "",
        }));

        const response = await this.$http.post(
          "api/genviteConflicts/updateConflicts",
          payload
        );

        // Handle API returning error in body
        if (response && response.error) {
          this.$notify({
            type: "error",
            group: "notification",
            text: response.error,
          });
          this.processing = false;
          return;
        }

        this.$notify({
          type: "success",
          group: "notification",
          text: "Accounts linked and conflict actions saved",
        });

        // Close dialogs and refresh
        this.conflictsDialog = false;
        this.confirmDialog = false;
        this.selectedRow = null;
        this.selectedAccount = null;
        if (this.$refs.grid && this.$refs.grid.reloadGrid) {
          this.$refs.grid.reloadGrid();
        }
      } catch (e) {
        const msg = "Failed to save conflicts";
        this.$notify({ type: "error", group: "notification", text: msg });
      } finally {
        this.processing = false;
      }
    },
    // Toggle handler for the Not Linked switch
    onShowNotLinkedChanged(value) {
      // Adjust the data source URL based on switch value
      if (value) {
        this.url = "genviteData?onlyNotLinked=true";
      } else {
        this.url = "genviteData?onlyNotLinked=";
      }

      // Use same reload pattern as Feedback.vue switch
      if (this.$refs.grid && this.$refs.grid.reloadDataSource) {
        this.$refs.grid.reloadDataSource(this.url);
      } else if (this.$refs.grid && this.$refs.grid.reloadGrid) {
        // Fallback if component exposes reloadGrid instead
        this.$refs.grid.reloadGrid();
      }
    },
    openImportDialog() {
      this.importDialog = true;
    },
    openSearchDialog(row) {
      this.selectedRow = row;
      this.searchDialog = true;

      this.donorsColumns.find(
        (d) => d.field == "lastHebrew"
      ).filterOptions.filterValue = row.hebrewLastName
        ? row.hebrewLastName.slice(0, 4)
        : "";

      this.donorsColumns.find(
        (d) => d.field == "firstHebrew"
      ).filterOptions.filterValue = row.hebrewFirstName
        ? row.hebrewFirstName.slice(0, 4)
        : "";

      this.donorsColumns.find(
        (d) => d.field == "address1"
      ).filterOptions.filterValue = row.addressLine1
        ? row.addressLine1.slice(0, 8)
        : "";

      this.showDonorsGrid = true;
    },
    closeSearchDialog() {
      this.selectedRow = {};
      this.searchDialog = false;

      this.donorsColumns.find(
        (d) => d.field == "lastHebrew"
      ).filterOptions.filterValue = "";

      this.donorsColumns.find(
        (d) => d.field == "firstHebrew"
      ).filterOptions.filterValue = "";

      this.donorsColumns.find(
        (d) => d.field == "address1"
      ).filterOptions.filterValue = "";

      this.showDonorsGrid = false;
    },
    onSearchAccountsRowClicked(account) {
      if (!this.selectedRow || !account || !account.personID) return;

      this.selectedAccount = account;
      this.searchDialog = false;

      this.confirmDialog = true;
    },
    async submitLinkAccount() {
      if (!this.selectedRow || !this.selectedAccount) return;

      try {
        this.processing = true;

        // Link the selected account to the Genvite person
        const response = await this.$http.post("api/genvite/linkAccount", {
          masterContactID: this.selectedRow.masterContactID,
          utaID: this.selectedAccount.personID,
          user: this.$store.state.authentication.user || "",
        });

        // API may return a normal 200 response containing an error & details
        const data = response && response.data ? response.data : response;
        if (data && data.error) {
          const details = Array.isArray(data.details)
            ? data.details.join("\n")
            : null;
          this.$notify({
            type: "error",
            group: "notification",
            text: details ? `${data.error}\n${details}` : data.error,
          });
          return; // Do not proceed to success path
        }

        // Check if conflicts were returned
        if (
          data &&
          data.conflicts &&
          Array.isArray(data.conflicts) &&
          data.conflicts.length > 0
        ) {
          this.conflicts = data.conflicts;
          this.conflictsDialog = true;
          this.confirmDialog = false;
          this.$refs.grid.reloadGrid();
          return; // Show conflicts dialog instead of success
        }

        this.$notify({
          type: "success",
          group: "notification",
          text: "Account linked successfully",
        });

        this.confirmDialog = false;
        this.selectedRow = null;
        this.selectedAccount = null;

        // Refresh the grid
        this.$refs.grid.reloadGrid();
      } catch (e) {
        // Attempt to surface structured error from server if present
        const errData =
          e && e.response && e.response.data ? e.response.data : null;
        if (errData && errData.error) {
          const details = Array.isArray(errData.details)
            ? errData.details.join("\n")
            : null;
          this.$notify({
            type: "error",
            group: "notification",
            text: details ? `${errData.error}\n${details}` : errData.error,
          });
        } else {
          this.$notify({
            type: "error",
            group: "notification",
            text: "Failed to link account",
          });
        }
      } finally {
        this.processing = false;
      }
    },
    pickFile() {
      this.$refs.importFileInput.click();
    },
    onFileChange(e) {
      this.uploading = true;

      const files = e.target.files;
      this.importFile = files && files.length > 0 ? files[0] : null;

      this.uploading = false;
    },
    async submitImport() {
      if (!this.importFile) return;

      this.importProcessing = true;

      try {
        const form = new FormData();
        // v-file-input binds a single File object
        form.append("file", this.importFile);

        const user =
          this.$store && this.$store.state && this.$store.state.authentication
            ? this.$store.state.authentication.user
            : "";

        const url = `api/genvite/import?user=${encodeURIComponent(user)}`;

        const responst = await this.$http.post(url, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$notify({
          type: "success",
          group: "notification",
          text: "Import submitted",
        });

        this.importDialog = false;
        this.importFile = null;

        // refresh grid
        this.$refs.grid.reloadGrid();
      } catch (e) {
        // axios interceptor will show error; optionally notify here
        // this.$notify({ type: 'error', text: 'Import failed' });
      } finally {
        this.importProcessing = false;
        if (this.$refs.importFileInput) {
          this.$refs.importFileInput.value = "";
        }
      }
    },
  },
};
</script>

<style>
.gray-fg {
  color: #999;
}
.selected-row {
  background-color: #e3f2fd !important;
}
.genvite-debug-log {
  width: 100%;
  height: 130px;
  font-family: Consolas, "Courier New", monospace;
  font-size: 12px;
  line-height: 1.4;
  resize: vertical;
  background: #fff;
  border: 1px solid #cfcfcf;
  padding: 8px;
  box-sizing: border-box;
}
</style>
